// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { signInPageLayout } from "@tps/App/Widgets/Layout/SignInPageLayout";
import { color, xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

signInPageLayout.container = {
    css: css`
        display: flex;
        gap: 40px;
        justify-content: center;
        margin-top: 40px;
        ${xScreen("lte", "md")} {
            gap: 30px;
            margin-top: 32px;
        }
        ${xScreen("lte", 767)} {
            flex-direction: column;
            gap: 36px;
        }
    `,
};

signInPageLayout.signInSection = {
    css: css`
        max-width: 400px;
        flex: 1;
    `,
};

signInPageLayout.divider = {
    css: css`
        border-left: 1px solid ${color("common.border")};
        width: 1px;
        ${xScreen("lte", 767)} {
            border-left: 0;
            border-top: 1px solid ${color("common.border")};
            height: 1px;
            width: 100%;
        }
    `,
};

signInPageLayout.createAccountSection = {
    css: css`
        max-width: 400px;
        flex: 1;
    `,
};
